import './App.css';
import Footer from './components/Footer/Footer';
import Routes from './config/RouteFile';

function App() {
  return (
    <div className='App'>
      <Routes />
      <Footer />
    </div>
  );
}

export default App;
